// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8c0495bb","455":"8f114fe5","977":"d2346933"}[chunkId] + ".chunk.js";
};